var haiso_extra_html = `<div style="text-align: right;padding-top: 2px; color: red;">
<p>【配送日時指定は必須です】<br>
【ギフト配送ご希望のお客様】<br>
発送元を「浅野屋オンラインショップ」から変更いたします。<br>
備考欄にご依頼主についてご記入ください。</p></div>`;

var haiso_intervalId = null;
var boundDateInput = null;

/**
 * 日付 チェック
 */
function isHaisoCompleted() {
  var dateInput = document.getElementById('haisoShippingdate');

  if (!dateInput) return false;
  if (dateInput.value.trim() === '') return false;

  return true;
}

/**
 * checkout 制御
 */
function updateCheckoutState() {
  var button = document.getElementById('checkout');
  if (!button) return;

  var completed = isHaisoCompleted();
  button.disabled = !completed;

  if (!haiso_intervalId) {
    haiso_intervalId = setInterval(updateCheckoutState, 1000);
  }
}



/**
 * haiso UI が揃ったら初期化
 */
function setupHaisoIfReady() {
  var haisoDateBlock = document.querySelector('.haiso_date');
  if (!haisoDateBlock) return;

  var dateInput = document.getElementById('haisoShippingdate');
  var timeSelect = document.getElementById('haisoShippingtime');

  if (!dateInput || !timeSelect) return;

  // 日付 input 差し替え対策
  if (boundDateInput !== dateInput) {
    boundDateInput = dateInput;
    dateInput.addEventListener('change', updateCheckoutState);
    dateInput.addEventListener('input', updateCheckoutState);
  }

  // 注意文言（重複防止）
  if (
    !haisoDateBlock.nextElementSibling ||
    !haisoDateBlock.nextElementSibling.classList.contains('haiso-extra')
  ) {
    haisoDateBlock.insertAdjacentHTML('afterend', haiso_extra_html);
  }

  // 保険ポーリング（datepicker が value 直書きするため）
  if (!haiso_intervalId) {
    haiso_intervalId = setInterval(updateCheckoutState, 1000);
  }

  updateCheckoutState();
  
  observer.disconnect();
}

/* --------------------------------
 * 初期状態：必ずブロック
 * -------------------------------- */
updateCheckoutState();

/* --------------------------------
 * MutationObserver（検知は存在確認型）
 * -------------------------------- */
var observer = new MutationObserver(function () {
  setupHaisoIfReady();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

